import React, { Component } from "react";
import MaskedInput from "react-text-mask";
import { Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import api from "../../services/Api";
import { checkIMEI } from "../../libs/Validate";
import { get } from "lodash";
import { isEmpty } from "validate.js";

class DadosForm extends Component {
  constructor(props) {
    super(props);
    this.dispositivo = {
      id: { value: "" },
      imei: { value: "" },
      imei2: { value: "" },
      marca: { value: "", ok: "" },
      modelo: { value: "" },
      operadora: { value: "" },
      serial: { value: "" },
      telefone: { value: "" },
      situacao: { value: "vazio" },
      userUid: { value: "" },
      numero_bo: { value: "" },
    };

    this.state = {
      imeiTwo: false,
      marcaOk: "",
      modeloOk: "",
      serialOk: "",
      operadoraOk: "",
      telefoneOk: "",
      imeiOk: "",
      imei2Ok: true,
      situacaoOk: false,
      fill: false,
      contatoRegex: [
        "(",
        /\d/,
        /\d/,
        ")",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
      imeiAux: "",
      imeiAux2: "",
      imeiValido: "",
      modal: false,
      modalImei: false,
      modalImeiText: false,
      DinamicBoForm: this.props.DinamicBo,
      InputErr: false,
      modalFields: false,
      fieldsError: {},
      errorMsg: "",
      estadoTelefoneInput: "",
      SendFromApi: false,
    };
  }

  componentDidUpdate() {
    this.fillForm();
  }

  componentWillMount() {
    this.triplice = this.props.triplice || {};
    this.receiveMarca();
    this.receiveOperadora();
    this.receiveSituacao();
  }

  receiveMarca = () => {
    const lista = this.triplice.MARCAS || [];
    const result = [{ id: 0, marca: "Selecione" }];
    lista.forEach((element) => {
      result[element.id] = element;
    });
    this.marcas = result;
  };

  receiveOperadora = () => {
    const lista = this.triplice.OPERADORAS || [];
    const result = [{ id: 0, operadora: "Selecione" }];
    lista.forEach((element) => {
      result[element.id] = element;
    });
    this.operadoras = result;
  };

  receiveSituacao = () => {
    const lista = this.triplice.SITUACOES || [];
    const result = [{ id: 0, situacao: "Selecione" }];
    lista.forEach((element) => {
      if (element.id !== 23) result[element.id] = element;
    });
    this.situacoes = result;
  };

  componentDidMount() {
    this.fillForm();
  }

  fillForm() {
    if (this.props.dispositivo !== null && this.state.fill === false) {
      this.setState({ estadoTelefoneInput: this.props.dispositivo.telefone });
      Object.entries(this.props.dispositivo).map((item) => {
        if (this.dispositivo[item[0]] !== undefined) {
          this.dispositivo[item[0]].value = item[1];
          switch (this.dispositivo[item[0]].id) {
            case "marca":
              this.triplice.MARCAS.forEach((element) => {
                if (element.marca === item[1]) {
                  this.dispositivo[item[0]].value = element.id;
                }
              });
              break;
            case "operadora":
              this.triplice.OPERADORAS.forEach((element) => {
                if (element.operadora === item[1]) {
                  this.dispositivo[item[0]].value = element.id;
                }
              });
              break;
            case "situacao":
              this.triplice.SITUACOES.forEach((element) => {
                if (element.situacao === item[1]) {
                  this.dispositivo[item[0]].value = element.id;
                }
              });
              break;
            default:
              break;
          }
        }

        return this.dispositivo[item[[0]]];
      });
      this.setState({
        fill: true,
        imeiAux: this.dispositivo.imei.value,
        imeiAux2: this.dispositivo.imei2.value !== "" ? this.dispositivo.imei2.value : "",
      });
      this.tratarEdit();
    }
  }
  //preenche o dispositivo

  handleClear = (event) => {
    this.setState({ fill: false });
    this.dispositivo.telefone = { value: "" };
    Object.entries(this.dispositivo).map((item) => {
      this.dispositivo[item[0]].value = "";
      return this.dispositivo[item[0]];
    });
  };
  //limpa o dispositivo

  checkFields = () => {
    if (this.validaIMEI(this.dispositivo.imei.value) === false) {
      this.setState({ fieldsError: { ...this.state.fieldsError, imei: false } });
    } else if (this.verificar() === false) {
      this.setState({ fieldsError: { ...this.state.fieldsError, campos: false } });
    } else if (this.validaIMEI(this.dispositivo.imei2.value) === false) {
      this.setState({ fieldsError: { ...this.state.fieldsError, imei2: false } });
    } else if (this.dispositivo.imei.value === this.dispositivo.imei2.value) {
      this.setState({ fieldsError: { ...this.state.fieldsError, imeisDiferentes: false } });
    }
  };
  //verifica os campos

  saveDisp = async (event) => {
    event.preventDefault();
    if (this.verificar() === false) {
      await this.setState({
        errorMsg:
          "Preencha todos os campos obrigatórios corretamente e/ou verifique se os IMEIs são diferentes",
      });
      this.setState({ modalFields: !this.state.modalFields });
    } else if (checkIMEI(this.dispositivo.imei.value) === false) {
      await this.setState({ errorMsg: "Verifique o IMEI 1 digitado" });
      this.setState({ modalFields: !this.state.modalFields });
    } else if (
      checkIMEI(this.dispositivo.imei2.value) === false &&
      this.dispositivo.imei2.value !== ""
    ) {
      await this.setState({ errorMsg: "Verifique o IMEI 2 digitado" });
      this.setState({ modalFields: !this.state.modalFields });
    } else if (this.dispositivo.imei.value === this.dispositivo.imei2.value) {
      await this.setState({ errorMsg: "Os IMEIs não podem ser iguais!" });
      this.setState({ modalFields: !this.state.modalFields });
    } else {
      this.setState({ SendFromApi: true });
      let newDipositivos = {};
      let dispositivoEstatico = {};
      dispositivoEstatico = this.dispositivo;
      dispositivoEstatico.telefone = { value: "" };
      Object.entries(dispositivoEstatico).map((item) => {
        newDipositivos[item[0]] = item[1].value;
        return newDipositivos[item[0]];
      });
      newDipositivos.telefone = this.state.estadoTelefoneInput;
      newDipositivos.userUid = this.props.userUid;
      newDipositivos.user_id = this.props.userId;

      await api
        .saveDispositivos(newDipositivos)
        .then(() => {
          this.setState({ SendFromApi: false });
          this.props.handlePush();
          this.handleClear();
          this.props.handleClearForm();
          this.props.cancelei();
        })
        .catch(async (err) => {
          const error = err.response || 1;
          if (error.status === 422) {
            let message = get(err, "response.data.numero_bo", "");
            if (isEmpty(message)) message = "Este imei já existe";
            console.log(">>>", message);
            this.setState({
              errorMsg: message,
              modalFields: !this.state.modalFields,
            });
          } else if (error.status === 401) {
            this.props.onModalToken();
          } else {
            this.setState({
              errorMsg: "Erro inesperado, favor entrar em contato com a administração do sistema",
              modalFields: !this.state.modalFields,
            });
          }
          this.setState({ SendFromApi: false });
        });
    }
  };
  //função criar dispositivo

  validaIMEI = (value) => {
    if (checkIMEI(value)) {
      this.setState({ imeiValido: true });
    } else {
      this.setState({ imeiValido: false, modalImei: true, modalImeiText: true });
    }
  };

  verificar = () => {
    if (
      this.state.marcaOk === true &&
      this.state.modeloOk === true &&
      this.state.operadoraOk === true &&
      this.state.telefoneOk === true &&
      this.state.imeiOk === true &&
      this.state.imei2Ok === true &&
      this.state.situacaoOk === true
    ) {
      return true;
    } else {
      return false;
    }
  };
  //verifica as validações de campos

  handleUpdate = async (e) => {
    e.preventDefault();

    if (this.verificar() === false) {
      await this.setState({
        errorMsg:
          "Preencha todos os campos obrigatórios corretamente e/ou verifique se os IMEIs são diferentes",
      });
      this.setState({ modalFields: !this.state.modalFields });
    } else if (this.validaIMEI(this.dispositivo.imei.value) === false) {
      await this.setState({ errorMsg: "Verifique o IMEI 1 digitado" });
      this.setState({ modalFields: !this.state.modalFields });
    } else if (
      this.validaIMEI(this.dispositivo.imei2.value) === false &&
      this.dispositivo.imei2.value !== ""
    ) {
      await this.setState({ errorMsg: "Verifique o IMEI 2 digitado" });
      this.setState({ modalFields: !this.state.modalFields });
    } else if (this.dispositivo.imei.value === this.dispositivo.imei2.value) {
      await this.setState({ errorMsg: "Os IMEIs não podem ser iguais!" });
      this.setState({ modalFields: !this.state.modalFields });
    } else {
      this.setState({ SendFromApi: true });
      let objeto = {};
      let dispositivoEstaticoUpdate = {};
      dispositivoEstaticoUpdate = this.dispositivo;
      dispositivoEstaticoUpdate.telefone = { value: "" };
      await Object.entries(dispositivoEstaticoUpdate).map((item) => {
        objeto[item[0]] = item[1].value;
        return objeto[item[0]];
      });
      objeto.telefone = this.state.estadoTelefoneInput;
      objeto.userUid = this.props.userUid;
      objeto.user_id = this.props.userId;

      await api
        .updateDispositivos(objeto)
        .then(async (res) => {
          this.setState({
            redirect: "/dispositivos",
            showButton: false,
            SendFromApi: false,
          });
          this.props.handlePush();
          this.handleClear();
          this.props.handleClearForm();
          this.props.handleShowButton();
          this.props.handleShowForm();
        })
        .catch(async (err) => {
          const error = err.response || 1;
          if (error.status === 422) {
            let message = get(err, "response.data.numero_bo", "");
            if (isEmpty(message)) message = "Este imei já existe";

            console.log(">>>", message);
            this.setState({
              errorMsg: message,
              modalFields: !this.state.modalFields,
            });
          } else if (error.status === 401) {
            this.props.onModalToken();
          } else {
            this.setState({
              errorMsg: "Erro inesperado, favor entrar em contato com a administração do sistema",
              modalFields: !this.state.modalFields,
            });
          }
          this.setState({ SendFromApi: false });
        });
    }
  };
  //função update do dispositivo

  handleShowForm = (e) => {
    e.preventDefault();
    this.props.handleClearForm();
    this.props.handleShowForm();
  };
  //função para mostrar o formulario e limpar os dados

  //validação do imei
  handleIsValid = (evento) => {
    evento.preventDefault();
    const campo = evento.target.id;
    const value = evento.target.value;
    switch (campo) {
      case "marca":
        if (value !== null && value !== "0") {
          this.setState({ marcaOk: true });
        } else {
          this.setState({ marcaOk: false });
        }
        break;

      case "modelo":
        if (
          value.match(
            /^([A-zà-ú0-9]{2,})?\s?([A-zà-ú0-9]{1,})\s?([A-zà-ú0-9]{1,})\s?([A-zà-ú0-9]{1,})?$/
          )
        ) {
          this.setState({ modeloOk: true });
        } else {
          this.setState({ modeloOk: false });
        }
        break;

      case "operadora":
        if (value !== null && value !== "0") {
          this.setState({ operadoraOk: true });
        } else {
          this.setState({ operadoraOk: false });
        }
        break;

      case "telefone":
        if (value.match(/^\(\d{2}\)\d{4,5}-\d{3,4}/) !== null) {
          this.setState({ telefoneOk: true });
        } else {
          this.setState({ telefoneOk: false });
        }
        break;

      case "imei":
        this.setState({ imeiAux: value.split("") });

        if (value.match(/^[0-9]{15}$/)) {
          this.setState({ imeiOk: true });
        } else {
          this.setState({ imeiOk: false });
        }
        break;

      case "imei2":
        this.setState({ imeiAux2: value.split("") });
        if ((value.match(/^[0-9]{15}$/) && value !== this.dispositivo.imei.value) || value === "") {
          this.setState({ imei2Ok: true });
        } else {
          this.setState({ imei2Ok: false });
        }
        break;

      case "situacao":
        if (value === "2" || value === "21" || value === "22" || value === "41" || value === "81") {
          this.setState({ DinamicBoForm: true });
        } else {
          this.setState({ DinamicBoForm: false });
        }
        if (value !== null && value !== "0") {
          this.setState({ situacaoOk: true });
        } else {
          this.setState({ situacaoOk: false });
        }
        break;

      default:
        break;
    }
  };
  //validação em tempo real

  tratarEdit = () => {
    if (this.dispositivo !== null) {
      this.setState({
        imeiOk: true,
        marcaOk: true,
        modeloOk: true,
        serialOk: true,
        operadoraOk: true,
        telefoneOk: true,
        situacaoOk: true,
      });
    } else {
      this.setState({
        imeiOk: false,
        marcaOk: false,
        modeloOk: false,
        serialOk: false,
        operadoraOk: false,
        telefoneOk: false,
        situacaoOk: false,
      });
    }
  };
  //trata edição dentro do fillform()

  render() {
    return (
      <div>
        <h4>Cadastro de Dispositivo</h4>
        <form className="FormFound form-row" style={{ color: "black" }}>
          <div className="form-group col-md-2">
            <label htmlFor="marca" style={{ color: "black" }}>
              Marca*
            </label>
            <Input
              invalid={!this.state.marcaOk}
              type="select"
              className="form-control"
              id="marca"
              innerRef={(ref) => (this.dispositivo.marca = ref)}
              onChange={this.handleIsValid}
            >
              {this.marcas.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.marca}
                </option>
              ))}
            </Input>
          </div>

          <div className="form-group col-md-3">
            <label htmlFor="modelo" style={{ color: "black" }}>
              Modelo*
            </label>
            <Input
              invalid={!this.state.modeloOk}
              className="form-control"
              type="text"
              id="modelo"
              innerRef={(ref) => (this.dispositivo.modelo = ref)}
              onChange={this.handleIsValid}
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="imei" style={{ color: "black" }}>
              IMEI*
            </label>
            <Input
              invalid={!this.state.imeiOk}
              className="form-control"
              type="text"
              id="imei"
              maxLength="15"
              innerRef={(ref) => (this.dispositivo.imei = ref)}
              onChange={this.handleIsValid}
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="imei2" style={{ color: "black" }}>
              IMEI2
            </label>
            <Input
              className="form-control"
              type="text"
              id="imei2"
              maxLength="15"
              onChange={this.handleIsValid}
              innerRef={(ref) => (this.dispositivo.imei2 = ref)}
            />
          </div>
          <div className="form-group col-md-2">
            <label htmlFor="operadora" style={{ color: "black" }}>
              Operadora*
            </label>
            <Input
              invalid={!this.state.operadoraOk}
              type="select"
              className="form-control"
              id="operadora"
              innerRef={(ref) => (this.dispositivo.operadora = ref)}
              onChange={this.handleIsValid}
            >
              {this.operadoras.map((o) => (
                <option key={o.id} value={o.id}>
                  {o.operadora}
                </option>
              ))}
            </Input>
          </div>

          <div className="form-group col-md-3">
            <label htmlFor="telefone" style={{ color: "black" }}>
              Telefone*
            </label>

            <MaskedInput
              mask={this.state.contatoRegex}
              showMask="true"
              invalid={!this.state.telefoneOk}
              className="form-control"
              type="text"
              id="telefone"
              value={this.state.estadoTelefoneInput}
              onChange={(e) => {
                this.handleIsValid(e);
                this.setState({ estadoTelefoneInput: e.target.value });
              }}
              render={(ref, props) => {
                return (
                  <Input
                    innerRef={(input) => (this.dispositivo.telefone = ref(input))}
                    {...props}
                  />
                );
              }}
            />
          </div>

          <div className="form-group col-md-3">
            <label htmlFor="serial" style={{ color: "black" }}>
              Serial
            </label>
            <input
              className="form-control"
              type="text"
              id="serial"
              ref={(input) => (this.dispositivo.serial = input)}
              placeholder="Não Obrigatório"
            />
          </div>

          <div className="form-group col-md-3">
            <label htmlFor="situacao" style={{ color: "black" }}>
              Situação*
            </label>
            <Input
              invalid={!this.state.situacaoOk}
              className="form-control"
              id="situacao"
              type="select"
              innerRef={(ref) => (this.dispositivo.situacao = ref)}
              onChange={this.handleIsValid}
            >
              {this.situacoes.map((s) => {
                if (s.id !== 23) {
                  return (
                    <option key={s.id} value={s.id}>
                      {s.situacao}
                    </option>
                  );
                }
                return null;
              })}
            </Input>
          </div>
          <div className={`form-group col-md-3 ${this.state.DinamicBoForm ? "" : "hide"}`}>
            <label htmlFor="numero_bo" style={{ color: "black" }}>
              Número de B.O
            </label>
            <Input
              size="100"
              className="form-control"
              type="text"
              id="numero_bo"
              innerRef={(ref) => (this.dispositivo.numero_bo = ref)}
            />
          </div>

          <div className="form-group col-md-12">
            <div className="form-row">
              <p>&nbsp;</p>
              {this.props.dispositivo !== null ? (
                <button
                  className="btn btn-primary btn-sm"
                  onClick={this.handleUpdate}
                  disabled={this.state.SendFromApi}
                >
                  {this.state.SendFromApi ? "Enviando" : "Atualizar Dispositivo"}
                </button>
              ) : (
                <button
                  className="btn btn-primary btn-sm"
                  onClick={this.saveDisp}
                  disabled={this.state.SendFromApi}
                >
                  {this.state.SendFromApi ? "Enviando" : "Inserir Dispositivo"}
                </button>
              )}
              <button className="btn btn-danger btn-sm ml-2" onClick={this.handleShowForm}>
                Cancelar
              </button>
              <p>&nbsp;</p>
            </div>
          </div>

          <div className="col-md-6">
            <Modal isOpen={this.state.modalFields}>
              <ModalHeader>Atenção</ModalHeader>
              <ModalBody>{this.state.errorMsg}</ModalBody>
              <ModalFooter>
                <button
                  className="btn btn-primary"
                  onClick={() => this.setState({ modalFields: !this.state.modalFields })}
                >
                  Entendi!
                </button>
              </ModalFooter>
            </Modal>
          </div>
        </form>
        &nbsp;
      </div>
    );
  }
}

export default DadosForm;



// WEBPACK FOOTER //
// ./src/components/Dispositivos/DadosForm.js